import { useLocation } from '@reach/router';

const useIsLocalhost = () => {
  const { hostname } = useLocation();

  return { isLocalhost: hostname === 'localhost' || hostname === '127.0.0.1' };
};

export default useIsLocalhost;
